import React, { Component, createRef, RefObject } from 'react'
import SignaturePad from 'signature_pad'
import Heading from './Heading'
import Card from './Card'
import Icon from './Icon'

interface SignatureProps {
  name: string
  label: string
  onChange: (name: string, signature: string) => void
}

export default class Signature extends Component<SignatureProps> {
  signaturePad: SignaturePad | null
  canvasRef: RefObject<HTMLCanvasElement>

  constructor (props: SignatureProps) {
    super(props)
    this.signaturePad = null
    this.canvasRef = createRef()
    this.handleClear = this.handleClear.bind(this)
  }

  handleClear () {
    const { signaturePad } = this
    if (signaturePad) {
      signaturePad.clear()
      this.props.onChange(this.props.name, '')
    }
  }

  handleChange () {
    const { signaturePad } = this
    if (signaturePad) {
      const dataUrl = signaturePad.toDataURL()
      this.props.onChange(this.props.name, dataUrl)
    }
  }

  initialize () {
    const canvas = this.canvasRef.current
    if (!canvas) return
    this.signaturePad = new SignaturePad(canvas, {
      onEnd: () => this.handleChange()
    })
  }

  componentDidMount () {
    this.initialize()
  }

  render () {
    return (
      <Card>
        <Heading
          className="mb-3"
          text={this.props.label} />
        <div className="relative">
          <canvas
            className="border border-primary border-dashed"
            ref={this.canvasRef}
            width="230"
            height="125" />
          <Icon
            className="absolute bottom-1 left-2"
            name="eraser"
            size="small"
            color="gray"
            onClick={this.handleClear} />
        </div>
      </Card>
    )
  }
}
